// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// // NOTICE: FaUniversity (Capital U)

// import { FaRupeeSign,FaTrash, FaBalanceScale,FaArrowDown,FaPhoneAlt, FaMoneyBillWave, FaFileAlt,  FaSignOutAlt, FaUserPlus, FaCalendarAlt } from 'react-icons/fa';
// import './Home.css';
// import topLogo from './logo-placeholder.png';
// import './ContactModal.css'; // Import the new CSS file

// const Home = () => {
//   const location = useLocation();
//   const navigate = useNavigate();



//   const [bankBalance, setBankBalance] = useState(0);   // For the Red Box
//   const [totalBalance, setTotalBalance] = useState(0); // For the Total Balance Box (if you have one)
  

//   // State for the "Do you want to exit?" Popup
//   const [showExitModal, setShowExitModal] = useState(false);
//   const [totalIncome, setTotalIncome] = useState(0);
//   // Add this next to your other states
//   const [totalExpense, setTotalExpense] = useState(0);
//   const [netBalance, setNetBalance] = useState(0);
//   const [showContactModal, setShowContactModal] = useState(false);
//   const [showDateModal, setShowDateModal] = useState(false);
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');



//   // --- 1. INTERCEPT BACK BUTTON ---
//   useEffect(() => {
//     // A. Push a "dummy" state into history so the user is "trapped" on this page
//     window.history.pushState(null, document.title, window.location.href);

//     // B. Function to run when Back Button is pressed
//     const handleBackButton = (event) => {
//       // Prevent the browser from going back
//       window.history.pushState(null, document.title, window.location.href);
//       // Show our custom popup
//       setShowExitModal(true);
//     };

//     // C. Listen for the back button event
//     window.addEventListener('popstate', handleBackButton);

//     // D. Cleanup when leaving the page
//     return () => {
//       window.removeEventListener('popstate', handleBackButton);
//     };
//   }, []);


//   // --- 2. FETCH DATA FROM BACKEND ---
//   useEffect(() => {

//     // A. Fetch Bank Balance (The new calculation: Online + Bank Deposit)
//     const fetchBankBalance = async () => {
//       try {
//         const response = await fetch('/api/dashboard/bank-balance');
//         const data = await response.json();
//         if (data.success) {
//           setBankBalance(data.total); // <--- Updates the Red Box number
//         }
//       } catch (error) {
//         console.error("Error fetching bank balance:", error);
//       }
//     };

//     // B. Fetch Total Balance (If you have this existing API)
//     const fetchTotalBalance = async () => {
//       try {
//         const response = await fetch('/api/dashboard/total-balance');
//         const data = await response.json();
//         if (data.success) {
//           setTotalBalance(data.total);
//         }
//       } catch (error) {
//         console.error("Error fetching total balance:", error);
//       }
//     };

//     // Call the new fetch

//     fetchBankBalance();
//     fetchTotalBalance();

//   }, []);

//   // 1. Get the user data sent from Login page


//   // 2. Read the Name from the database (or show "Guest" if missing)
//   // Note: Check if your DB column is 'FullName' or 'fullname' (Case Sensitive in JS!)
//   const user = location.state?.user || JSON.parse(localStorage.getItem('user'));
//   const userName = user?.name || user?.name || "Gayatri Member";

//   // --- 2. POPUP BUTTON ACTIONS ---
//   const handleYesLogout = () => {
//      localStorage.removeItem('user');
//         localStorage.removeItem('token'); 
//         localStorage.removeItem('isLoggedIn');
//         navigate('/'); 
//   };

//   const handleNoStay = () => {
//     setShowExitModal(false); // Close popup, stay here
//   };

//   // --- MANUAL LOGOUT BUTTON ---
//   const handleManualLogout = () => {
//     setShowExitModal(true);

//   };

//   // 1. NEW STATE for the Year
//   const [financialYear, setFinancialYear] = useState('Loading...');

//   // 2. FETCH FUNCTION
//   useEffect(() => {
//     const fetchYear = async () => {
//       try {




//         const response = await fetch('/api/dashboard/year');
//         const data = await response.json();

//         // Fetch Income
//         const incomeRes = await fetch('/api/dashboard/income');
//         const incomeData = await incomeRes.json();

//         // NEW: Fetch Expense
//         const expenseRes = await fetch('/api/dashboard/expense');
//         const expenseData = await expenseRes.json();
//         // NEW: Fetch Balance
//         const balanceRes = await fetch('/api/dashboard/balance');
//         const balanceData = await balanceRes.json();

//         if (balanceData.success) {
//           setNetBalance(balanceData.total);
//         }
//         if (data.success) {
//           setFinancialYear(data.year); // Set the year from DB
//         }
//         else {
//           setFinancialYear('2025-2026'); // Fallback if DB is empty
//         }
//         if (incomeData.success) {
//           setTotalIncome(incomeData.total); // <--- This will now receive the filtered total
//         }
//         if (expenseData.success) {
//           setTotalExpense(expenseData.total);
//         }
//       } catch (error) {
//         console.error("Error fetching year:", error);
//       }
//     };

//     fetchYear();
//   }, [financialYear]); // Run once on page load


//   // --- NEW: HANDLER TO SAVE DATES ---
//   const handleSaveDates = async () => {
//     if (!fromDate || !toDate) {
//       alert("Please select both From and To dates");
//       return;
//     }

//     try {
//       const response = await fetch('/api/dashboard/set-financial-year', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           dateFrom: fromDate,
//           dateTo: toDate
//         }),
//       });

//       const result = await response.json();

//       if (result.success) {
//         alert("✅ " + result.message);
//         setShowDateModal(false); // Close popup
//       } else {
//         alert("❌ Error: " + result.message);
//       }
//     } catch (error) {
//       console.error(error);
//       alert("❌ Server Error");
//     }
//   };

//   return (
//     <div className="dashboard-container">
//       {/* ... (Header and Stats Cards remain the same) ... */}

//       {/* --- POPUP MODAL --- */}
//       {showExitModal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <h3>Warning</h3>
//             <p>Do you want to Sign Out?</p>
//             <div className="modal-actions">
//               {/* These buttons now handle both Back Button AND Sign Out Button */}
//               <button className="modal-btn yes-btn" onClick={handleYesLogout}>Yes</button>
//               <button className="modal-btn no-btn" onClick={handleNoStay}>No</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Header Section */}

//       <div className="dash-header">

//         <button className="logout-btn" onClick={handleManualLogout}>
//           <FaSignOutAlt /> <span>Sign Out</span> {/* Wrap text in span */}
//         </button>
//         <div className="header-top">
//           <img src={topLogo} alt="Logo" className="dash-logo" />
//           <div className="header-text">
//             <h2>गायत्री परिवार</h2>
//             <h3>अलीराजपुर</h3>
//           </div>
//         </div>
//         <h2 className="welcome-text">स्वागत हे ! !</h2>
//         <h1 className="user-name">{userName}</h1>
//       </div>

//       {/* Stats Card 1 */}
//       <div className="stats-card">
//         <h3 className="card-title"><h3 className="card-title">वार्षिक सत्र:- {financialYear}</h3></h3>
//         <div className="circle-container">

//           <div className="stat-item">
//             <div className="circle purple"><span>{totalIncome}</span></div>
//             <p>कुल आय राशि</p>
//           </div>
//           <div className="stat-item">
//             <div className="circle green"><span>{totalExpense}</span></div>
//             <p>कुल खर्च राशि</p>
//           </div>
//           <div className="stat-item">
//             <div className="circle orange"><span>{netBalance}</span></div>
//             <p>कुल नगद राशि</p>
//           </div>
//         </div>


//       </div>

//       {/* Stats Card 2 */}
//       <div className="stats-card small-card">
//         <div className="pill-container">
//           <div className="pill-item">
//             <div className="pill red">{bankBalance}</div>
//             <p>बैंक बैलेंस</p>
//           </div>
//           <div className="pill-item">
//             <div className="pill pink">{netBalance + bankBalance}</div>
//             <p>कुल राशि</p>
//           </div>
//         </div>
//       </div>

//       {showContactModal && (
//         <div className="modal-overlay">
//           <div className="contact-modal-box">
//             {/* Header (Fixed Top) */}
//             <div className="modal-header">
//               <img src={topLogo} alt="Logo" className="modal-logo" />
//               <div>
//                 <h2>गायत्री परिवार</h2>
//                 <h3>अलीराजपुर</h3>
//               </div>
//             </div>

//             {/* --- SCROLLABLE CONTENT AREA (Updated Class Name) --- */}
//             <div className="modal-content-scrollable">
//               {/* Administration Section */}
//               <h3 className="modal-section-title">Administration</h3>
//               <h2 className="modal-subheading">गायत्री परिवार ट्रस्ट</h2>
//               <p>गायत्री शक्तिपीठ, अलीराजपुर, जिला - अलीराजपुर 457887 (म.प्र.)</p>
//               <p>(पंजीयन क्र. 1/B-113/1991/92)</p>
//               <p>(PAN - AAATG7269D)</p>

//               {/* Development Section */}
//               <h3 className="modal-section-title">Development</h3>
//               <p>Gyanpravidhi Technologies Pvt. Ltd.</p>
//               <p>108, Fortune Aura Business Space, Bhawarkua Main Road, Indore (M.P.)</p>
//               <p>Contact Us at :- 9826752262</p>
//               <p>Email us at:- gptechnolohiesindore@gmail.com</p>

//               {/* About App Section */}
//               <h3 className="modal-section-title">About_App</h3>
//               <p>This application has been developed to perform specific task to manage the financial records of the trust. This application has been designed to digitalize the manuall work of the trust.</p>
//             </div>

//             {/* OK Button (Fixed Bottom) */}
//             <button className="modal-ok-btn" onClick={() => setShowContactModal(false)}>
//               OK
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ========================================= */}
//       {/* NEW POPUP: FIX DATE FOR YEAR              */}
//       {/* ========================================= */}
//       {showDateModal && (
//         <div className="modal-overlay">
//           <div className="contact-modal-box" style={{ height: 'auto', maxWidth: '350px', padding: '20px' }}>

//             {/* Header */}
//             <div className="modal-header" style={{ marginBottom: '20px' }}>
//               <h2 style={{ textDecoration: 'none', color: '#4a148c', fontSize: '1.5rem' }}>Fix Date For Year</h2>
//             </div>

//             {/* Content: Date Inputs */}
//             <div className="modal-content" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>

//               {/* From Date */}
//               <div style={{ textAlign: 'left' }}>
//                 <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px', color: '#333' }}>From Date (दिनांक से):</label>
//                 <input
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '12px',
//                     borderRadius: '10px',
//                     border: '1px solid #ccc',
//                     fontSize: '1rem',
//                     boxSizing: 'border-box' /* Ensures padding doesn't widen input */
//                   }}
//                 />
//               </div>

//               {/* To Date */}
//               <div style={{ textAlign: 'left' }}>
//                 <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px', color: '#333' }}>To Date (दिनांक तक):</label>
//                 <input
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '12px',
//                     borderRadius: '10px',
//                     border: '1px solid #ccc',
//                     fontSize: '1rem',
//                     boxSizing: 'border-box'
//                   }}
//                 />
//               </div>

//             </div>

//             {/* Buttons Section - FIXED LAYOUT */}
//             <div style={{
//               marginTop: '25px',
//               display: 'flex',
//               gap: '15px',
//               justifyContent: 'space-between',
//               width: '100%'
//             }}>
//               <button
//                 className="modal-ok-btn"
//                 onClick={handleSaveDates}
//                 style={{
//                   backgroundColor: '#66bb6a', /* Green */
//                   flex: 1, /* Takes 50% space */
//                   margin: 0 /* Remove default margins */
//                 }}
//               >
//                 SAVE DATE
//               </button>

//               <button
//                 className="modal-ok-btn"
//                 onClick={() => setShowDateModal(false)}
//                 style={{
//                   backgroundColor: '#ef5350', /* Red */
//                   flex: 1, /* Takes 50% space */
//                   margin: 0
//                 }}
//               >
//                 CANCEL
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Icons Grid */}
//       <div className="menu-grid">
//         <div className="menu-box"
//           onClick={() => navigate('/prapt-aai')} // <--- UPDATED LINK
//           style={{ cursor: 'pointer' }}>
//           <FaMoneyBillWave className="menu-icon" />
//           <p>प्राप्त आय</p>
//         </div>
//         <div className="menu-box"
//           onClick={() => navigate('/kharch-aai')} // <--- UPDATED LINK
//           style={{ cursor: 'pointer' }}>
//           <FaRupeeSign className="menu-icon" />
//           <p>खर्च आय</p>
//         </div>





//         {/* --- NEW TAB: ADD NEW USER --- */}
//         <div className="menu-box" onClick={() => navigate('/add-new-user')}>
//           <FaUserPlus className="menu-icon" />
//           <p>ADD NEW USER</p>
//         </div>

//         {/* --- NEW ITEM 6: Fix Date --- */}
//         <div className="menu-box" onClick={() => setShowDateModal(true)}>

//           <FaCalendarAlt className="menu-icon" />
//           <p>Fix Date for Year</p>
//         </div>

//         <div className="menu-box" onClick={() => setShowContactModal(true)}>
//           <FaPhoneAlt className="menu-icon" />
//           <p>Contact Information</p>
//         </div>
//       </div>


// {/* --- NEW CARD: REPORTS HEADER --- */}
//             <div className="reports-header-card">
//                 <h3>रिपोर्ट्स</h3>
//                 <FaArrowDown className="down-arrow-icon" />
//             </div>

//  {/* --- NEW REPORTS GRID (4 Tabs) --- */}
//             <div className="reports-grid-4"> 
                 
//                  {/* 1. Annual Report (वार्षिक रिपोर्ट) */}
//                  <div className="report-box box-blue" onClick={() => navigate('/annual-report')}>
//                      <FaFileAlt className="report-icon" />
//                      <p>वार्षिक रिपोर्ट</p>
//                  </div>

//                  {/* 2. Income Report (आय की रिपोर्ट) */}
//                  <div className="report-box box-green" onClick={() => navigate('/income-report')}>
//                      <FaMoneyBillWave className="report-icon" />
//                      <p>आय की रिपोर्ट</p>
//                  </div>

//                  {/* 3. Expense Report (व्यय की रिपोर्ट) */}
//                  <div className="report-box box-red" onClick={() => navigate('/expense-report')}>
//                      <FaRupeeSign className="report-icon" />
//                      <p>व्यय की रिपोर्ट</p>
//                  </div>

//                  {/* 4. Income-Expense Sheet (आय व्यय पत्रक) */}
//                  <div className="report-box box-purple" onClick={() => navigate('/aay-vyay-patrak')}>
//                      <FaBalanceScale className="report-icon" />
//                      <p>आय व्यय पत्रक</p>
//                  </div>

//                  {/* 5. DELETE-WRONG ENTRY (आय व्यय ) */}
//                  <div className="report-box box-red" onClick={() => navigate('/delete-entry')}>
//                      <FaTrash className="report-icon"/>
//                      <p>गलत एंट्री हटाये</p>
//                  </div>


//             </div>
//     </div>
//   );
// };

// export default Home;



import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  FaRupeeSign, FaTrash, FaBalanceScale, FaPhoneAlt, 
  FaMoneyBillWave, FaFileAlt, FaSignOutAlt, FaUserPlus, 
  FaCalendarAlt, FaUniversity, FaWallet, FaChartPie
} from 'react-icons/fa';

import './Home.css';
import topLogo from './logo-placeholder.png';
import './ContactModal.css'; 

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // --- STATES ---
  const [bankBalance, setBankBalance] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [netBalance, setNetBalance] = useState(0);
  const [financialYear, setFinancialYear] = useState('Loading...');

  // --- MODAL STATES ---
  const [showExitModal, setShowExitModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const user = location.state?.user || JSON.parse(localStorage.getItem('user'));
  const userName = user?.name || "Gayatri Member";

  // --- 1. INTERCEPT BACK BUTTON ---
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    const handleBackButton = (event) => {
      window.history.pushState(null, document.title, window.location.href);
      setShowExitModal(true);
    };
    window.addEventListener('popstate', handleBackButton);
    return () => window.removeEventListener('popstate', handleBackButton);
  }, []);

  // --- 2. FETCH DASHBOARD DATA (SAFE & INDEPENDENT) ---
  useEffect(() => {
    
    // 1. Fetch Financial Year
    fetch('/api/dashboard/year')
      .then(res => res.json())
      .then(data => {
        if (data.success) setFinancialYear(data.year);
        else setFinancialYear('2025-2026');
      })
      .catch(err => {
        console.error("Year Error:", err);
        setFinancialYear('2025-2026');
      });

    // 2. Fetch Bank Balance
    fetch('/api/dashboard/bank-balance')
      .then(res => res.json())
      .then(data => { if (data.success) setBankBalance(data.total || 0); })
      .catch(err => console.error("Bank Balance Error:", err));

    // 3. Fetch Total Income
    fetch('/api/dashboard/income')
      .then(res => res.json())
      .then(data => { if (data.success) setTotalIncome(data.total || 0); })
      .catch(err => console.error("Income Error:", err));

    // 4. Fetch Total Expense
    fetch('/api/dashboard/expense')
      .then(res => res.json())
      .then(data => { if (data.success) setTotalExpense(data.total || 0); })
      .catch(err => console.error("Expense Error:", err));

    // 5. Fetch Net Balance
    fetch('/api/dashboard/balance')
      .then(res => res.json())
      .then(data => { if (data.success) setNetBalance(data.total || 0); })
      .catch(err => console.error("Balance Error:", err));

  }, []); // Run once on component mount

  // --- HANDLERS ---
  const handleYesLogout = () => {
    localStorage.clear();
    navigate('/'); 
  };

  const handleSaveDates = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both From and To dates");
      return;
    }
    try {
      const response = await fetch('/api/dashboard/set-financial-year', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ dateFrom: fromDate, dateTo: toDate }),
      });
      const result = await response.json();
      if (result.success) {
        alert("✅ " + result.message);
        setShowDateModal(false);
        window.location.reload(); // Reload to fetch new year data
      } else {
        alert("❌ Error: " + result.message);
      }
    } catch (error) {
      alert("❌ Server Error");
    }
  };

  return (
    <div className="home-dashboard-wrapper">
      
      {/* --- TOP NAVBAR --- */}
      <nav className="home-top-nav">
        <div className="nav-brand" onClick={() => navigate("/home")}>
          <img src={topLogo} alt="Logo" className="nav-logo" />
          <div className="nav-brand-text">
            <h2>गायत्री परिवार</h2>
            <h3>अलीराजपुर</h3>
          </div>
        </div>
        <button className="nav-logout-btn" onClick={() => setShowExitModal(true)}>
          <FaSignOutAlt size={18} />
          <span>Sign Out</span>
        </button>
      </nav>

      {/* --- MAIN DASHBOARD CONTENT --- */}
      <main className="home-main-content">
        
        {/* 1. WELCOME HERO SECTION */}
        <section className="hero-welcome-banner">
          <div className="hero-text">
            <h1>स्वागत है, {userName}!</h1>
            <p>वित्तीय वर्ष: <strong>{financialYear}</strong> का सारांश</p>
          </div>
          <FaChartPie className="hero-icon-bg" />
        </section>

        {/* 2. FINANCIAL STATS CARDS */}
        <section className="financial-stats-grid">
          <div className="stat-card stat-income">
            <div className="stat-icon-wrapper"><FaMoneyBillWave /></div>
            <div className="stat-details">
              <p>कुल आय राशि</p>
              <h3>₹ {totalIncome}</h3>
            </div>
          </div>

          <div className="stat-card stat-expense">
            <div className="stat-icon-wrapper"><FaRupeeSign /></div>
            <div className="stat-details">
              <p>कुल खर्च राशि</p>
              <h3>₹ {totalExpense}</h3>
            </div>
          </div>

          <div className="stat-card stat-cash">
            <div className="stat-icon-wrapper"><FaWallet /></div>
            <div className="stat-details">
              <p>कुल नगद राशि</p>
              <h3>₹ {netBalance}</h3>
            </div>
          </div>

          <div className="stat-card stat-bank">
            <div className="stat-icon-wrapper"><FaUniversity /></div>
            <div className="stat-details">
              <p>बैंक बैलेंस</p>
              <h3>₹ {bankBalance}</h3>
            </div>
          </div>

          <div className="stat-card stat-total">
            <div className="stat-icon-wrapper"><FaBalanceScale /></div>
            <div className="stat-details">
              <p>कुल राशि (GRAND TOTAL)</p>
              <h3>₹ {netBalance + bankBalance}</h3>
            </div>
          </div>
        </section>

        {/* 3. TWO-COLUMN LAYOUT FOR ACTIONS AND REPORTS */}
        <div className="dashboard-split-layout">
          
          {/* LEFT: QUICK ACTIONS */}
          <section className="dashboard-panel">
            <div className="panel-header">
              <h3>त्वरित कार्य (Quick Actions)</h3>
            </div>
            <div className="panel-grid-actions">
              <div className="action-box box-green" onClick={() => navigate('/prapt-aai')}>
                <FaMoneyBillWave className="box-icon" />
                <p>प्राप्त आय (Add Income)</p>
              </div>
              <div className="action-box box-red" onClick={() => navigate('/kharch-aai')}>
                <FaRupeeSign className="box-icon" />
                <p>खर्च आय (Add Expense)</p>
              </div>
              <div className="action-box box-blue" onClick={() => navigate('/add-new-user')}>
                <FaUserPlus className="box-icon" />
                <p>नया यूजर जोड़ें</p>
              </div>
              <div className="action-box box-purple" onClick={() => setShowDateModal(true)}>
                <FaCalendarAlt className="box-icon" />
                <p>तारीख सेट करें (Fix Date)</p>
              </div>
              <div className="action-box box-orange" onClick={() => setShowContactModal(true)}>
                <FaPhoneAlt className="box-icon" />
                <p>सम्पर्क सूत्र (Contact)</p>
              </div>
              <div className="action-box box-gray" onClick={() => navigate('/delete-entry')}>
                <FaTrash className="box-icon" />
                <p>गलत एंट्री हटाये</p>
              </div>
            </div>
          </section>

          {/* RIGHT: REPORTS */}
          <section className="dashboard-panel">
            <div className="panel-header">
              <h3>रिपोर्ट्स (Reports)</h3>
            </div>
            <div className="panel-grid-reports">
              <div className="report-list-item" onClick={() => navigate('/annual-report')}>
                <div className="report-icon-circle blue-bg"><FaFileAlt /></div>
                <div className="report-info">
                  <h4>वार्षिक रिपोर्ट</h4>
                  <p>पूरे वर्ष का सारांश देखें</p>
                </div>
              </div>

              <div className="report-list-item" onClick={() => navigate('/income-report')}>
                <div className="report-icon-circle green-bg"><FaMoneyBillWave /></div>
                <div className="report-info">
                  <h4>आय की रिपोर्ट</h4>
                  <p>सभी प्राप्तियों का विवरण</p>
                </div>
              </div>

              <div className="report-list-item" onClick={() => navigate('/expense-report')}>
                <div className="report-icon-circle red-bg"><FaRupeeSign /></div>
                <div className="report-info">
                  <h4>व्यय की रिपोर्ट</h4>
                  <p>सभी खर्चे का विवरण</p>
                </div>
              </div>

              <div className="report-list-item" onClick={() => navigate('/aay-vyay-patrak')}>
                <div className="report-icon-circle purple-bg"><FaBalanceScale /></div>
                <div className="report-info">
                  <h4>आय व्यय पत्रक</h4>
                  <p>विस्तृत लेज़र (Ledger) और प्रिंट</p>
                </div>
              </div>
            </div>
          </section>

        </div>
      </main>

      {/* ========================================= */}
      {/* MODALS SECTION                              */}
      {/* ========================================= */}
      
      {/* 1. EXIT MODAL */}
      {showExitModal && (
        <div className="pro-modal-overlay">
          <div className="pro-modal-box">
            <h3 className="pro-modal-title">Sign Out?</h3>
            <p className="pro-modal-desc">क्या आप सुरक्षित रूप से लॉग आउट करना चाहते हैं?</p>
            <div className="pro-modal-actions">
              <button className="btn-no" onClick={() => setShowExitModal(false)}>No, Stay</button>
              <button className="btn-yes" onClick={handleYesLogout}>Yes, Sign Out</button>
            </div>
          </div>
        </div>
      )}

      {/* 2. SET DATE MODAL */}
      {showDateModal && (
        <div className="pro-modal-overlay">
          <div className="pro-modal-box">
            <h3 className="pro-modal-title">Fix Date For Year</h3>
            <div className="pro-form-group">
              <label>From Date (दिनांक से):</label>
              <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
            </div>
            <div className="pro-form-group">
              <label>To Date (दिनांक तक):</label>
              <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
            </div>
            <div className="pro-modal-actions">
              <button className="btn-no" onClick={() => setShowDateModal(false)}>Cancel</button>
              <button className="btn-yes bg-green" onClick={handleSaveDates}>Save Date</button>
            </div>
          </div>
        </div>
      )}

      {/* 3. CONTACT MODAL */}
      {showContactModal && (
        <div className="pro-modal-overlay">
          <div className="contact-modal-box">
            <div className="modal-header">
              <img src={topLogo} alt="Logo" className="modal-logo" />
              <div>
                <h2>गायत्री परिवार</h2>
                <h3>अलीराजपुर</h3>
              </div>
            </div>
            <div className="modal-content-scrollable">
              <h3 className="modal-section-title">Administration</h3>
              <h2 className="modal-subheading">गायत्री परिवार ट्रस्ट</h2>
              <p>गायत्री शक्तिपीठ, अलीराजपुर, जिला - अलीराजपुर 457887 (म.प्र.)</p>
              <p>(पंजीयन क्र. 1/B-113/1991/92)</p>
              <p>(PAN - AAATG7269D)</p>
              
              <h3 className="modal-section-title">Development</h3>
              <p><strong>Gyanpravidhi Technologies Pvt. Ltd.</strong></p>
              <p>108, Fortune Aura Business Space, Bhawarkua Main Road, Indore (M.P.)</p>
              <p>Contact Us: 9826752262</p>
              <p>Email: gptechnolohiesindore@gmail.com</p>

              <h3 className="modal-section-title">About App</h3>
              <p>This application has been developed to perform specific task to manage the financial records of the trust. This application has been designed to digitalize the manual work of the trust.</p>
            </div>
            <button className="modal-ok-btn" onClick={() => setShowContactModal(false)}>OK</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Home;